module.exports = __webpack_public_path__ + "static/bigminer-qr-pricing-9612ee7de88d92bb51fd537e55d01f10.svg";